import { useCallback } from "react";
import { TaskStatusEnum } from "../types";
import { useTasksNavigation } from "../hooks";
import { PropsType } from "./types";
import { useDeleteDraftDialogContext } from "src/components/Drafts";

export const useTasksContextMenu = ({
  row,
  onDeleteDraftConfirmed,
}: PropsType) => {
  const {
    handleOnClick: handleOnClickView,
    navigate,
    location,
  } = useTasksNavigation(row);
  const { openDialog: openDeleteDraftDialog } = useDeleteDraftDialogContext();

  const showCTEntrance = row.requestStatus === TaskStatusEnum.COMPLETED;
  const showDeleteDraftEntrance =
    row.requestStatus === TaskStatusEnum.ASSIGNED_TO_ME;

  const handleOnClickClose = useCallback(() => {
    navigate(`/new-premise/${row.id}/close-transfer`, {
      state: {
        backUrl: location.pathname + location.search,
      },
    });
  }, [row]);

  const handleOnClickDelete = useCallback(() => {
    openDeleteDraftDialog({
      onDeleteDraft: onDeleteDraftConfirmed,
    });
  }, [onDeleteDraftConfirmed]);

  return {
    handleOnClickClose,
    handleOnClickView,
    handleOnClickDelete,
    showCTEntrance,
    showDeleteDraftEntrance,
  };
};
